import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GSC_SUMMARY_KEY } from '../../constants/queryKeys';
import { GET_GSC_SUMMARY_URL } from '../../constants/apiUrls';
import { GetGroupSCReviewResponse } from './useGetGroupSCReview';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GetGroupSCSummaryResponse {
  applicationId: string;
  status: string;
  applicationDateTime: string;
  coordinatorName: string;
  specialConsiderationGroupRequestReview: GetGroupSCReviewResponse;
  amendable: boolean;
  dateToReply: string;
  seabRemark: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetGroupSCSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetGroupSCSummary = ({ uuid, onSuccess, onError }: Input) => {
  const getGroupSCSummary = async () => {
    const res = await axiosClient.get<GetGroupSCSummaryResponse>(GET_GSC_SUMMARY_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_GSC_SUMMARY_KEY], getGroupSCSummary, {
    onSuccess,
    onError,
  });
};
